<template>
    <li class="reply">
        <TransitionEffect>
            <Dialog
                v-if="deleteReplyDialog"
                appearance="red"
                primaryIcon="delete"
                @primary="deleteReply"
                @secondary="deleteReplyDialog=false"
                @close="deleteReplyDialog=false">
                <template slot="header">{{ siteContent.deleteCommentDialog }}</template>
                <template slot="body">{{ siteContent.thinkTwice }}</template>
                <template slot="secondary">{{ siteContent.cancel }}</template>
                <template slot="primary">{{ siteContent.delete }}</template>
            </Dialog>
        </TransitionEffect>

        <div class="head">
            <Contributor
                v-if="!loading"
                :slug="writtenByUser.slug"
                :avatar="writtenByUser.avatar"
                :name="writtenByUser.name">
            </Contributor>

            <time class="timeStamp">
                {{ reply.timestamp.toDate() | moment("from", "now") }}
            </time>
        </div>
        
        <p class="content">
            <router-link class="writtenTo"
                v-if="writtenToUser"
                :to="'/creator/' + writtenToUser.slug">
                {{ writtenToUser.name }}
            </router-link>
            {{ reply.content }}
        </p>
        <div class="actions">
            <a class="replyButton"
                v-if="auth.id"
                tabindex="0"
                @click="$emit('replyTo', writtenByUser)">
                {{ siteContent.reply }}
            </a>
            <a class="replyButton"
                tabindex="0"
                v-if="auth.id === reply.writtenBy"
                @click="deleteReplyDialog = true">
                {{ siteContent.delete }}
            </a>
        </div>
    </li>
</template>

<script>
    import { db } from '@/firebase'

    import Contributor from '@/components/entry/Contributor'

    export default {
        name: 'Reply',
        components: {
            Contributor
        },
        props: {
            collection: {
                type: String,
                required: true
            },
            reply: {
                type: Object,
                required: true
            },
            parentId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                writtenByUser: { },
                writtenToUser: { },
                deleteReplyDialog: false,
                loading: true
            }
        },
        async mounted() {
            const writtenByRef = await db
                .collection('users')
                .doc(this.reply.writtenBy)
                .get()

            this.writtenByUser = {
                ...writtenByRef.data(),
                id: this.reply.writtenBy
            }

            this.loading = false

            if(this.reply.writtenTo) {
                const writtenToRef = await db
                    .collection('users')
                    .doc(this.reply.writtenTo)
                    .get()

                this.writtenToUser = {
                    ...writtenToRef.data(),
                    id: this.reply.writtenTo
                }
            }
        },
        methods: {
            async deleteReply() {
                try {
                    await db
                        .collection(this.collection)
                        .doc(this.parentId)
                        .collection('replies')
                        .doc(this.reply.id)
                        .delete()

                    console.log('Reply deleted.')
                } catch(error) {
                    console.log(error)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .reply {
        margin: 0 0 2rem 3rem;
        list-style: none;
    }

    .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .timeStamp {
        font-size: 1rem;
        color: var(--color-grey-500);
    }

    .replyButton {
        color: var(--color-grey-500);
        margin-left: 1rem;
        font-size: 1rem;
        cursor: pointer;
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
    }

    .content {
        margin: 0.5rem 0 0 3rem;
        text-align: left;
    }

    .writtenTo {
        margin-right: 0.5rem;
    }

    .actions {
        display: flex;
        margin-left: 1.5rem;
    }
</style>